import type { RouteObject } from 'react-router-dom';
import { conversationsPanelEnabled } from '../../config';

/**
 * web-ui-only Conversation Workspace preview route (Init014). Empty unless the dev flag is on, and
 * because the flag is a compile-time constant the lazy `import()` below is dead code in a default
 * build: no route, no chunk, no bytes on the shared routes.
 *
 * No `handle.telemetryRoute` yet — a token needs an architect grant and a gateway allowlist entry
 * first (same path the `account` token took); until then a render failure here is unattributed.
 */
export const conversationRoutes: RouteObject[] = conversationsPanelEnabled
  ? [
      {
        path: '/conversations',
        lazy: () => import('./ConversationsPage').then((m) => ({ Component: m.ConversationsRoute })),
      },
    ]
  : [];
